import { motion } from "framer-motion";
import { Check, X, Crown } from "lucide-react";

const them = [
  "Just haul your junk away",
  "Leave dust and debris behind",
  "Hidden fees & surprise upcharges",
  "One-and-done — never hear from them again",
];

const us = [
  "Full-service Garage Reset",
  "Floors swept and left spotless",
  "Transparent, upfront pricing",
  "Lifetime access to our partner network",
];

export const Comparison = () => (
  <section id="why-us" className="bg-background py-12 md:py-16">
    <div className="container">
      <div className="mb-12 text-center">
        <p className="mb-3 text-sm font-semibold uppercase tracking-[0.3em] text-gold">Why Us</p>
        <h2 className="font-display text-5xl tracking-wide text-ink md:text-6xl">The Garage Kings Difference</h2>
        <p className="mx-auto mt-4 max-w-2xl text-muted-foreground">
          See why Edmonton homeowners choose us over the typical junk truck.
        </p>
      </div>

      <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="rounded-2xl border-2 border-border bg-card p-6 sm:p-8"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-muted-foreground">The Other Guys</p>
          <h3 className="mt-2 font-display text-3xl tracking-wide text-ink">Generic Junk Haulers</h3>
          <ul className="mt-6 space-y-4">
            {them.map((t) => (
              <li key={t} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-muted">
                  <X className="h-4 w-4 text-muted-foreground" />
                </span>
                <span className="text-muted-foreground">{t}</span>
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="relative rounded-2xl border-2 border-gold bg-gradient-to-br from-navy via-ink to-navy p-6 shadow-gold sm:p-8"
        >
          <div className="absolute -top-3 right-6 rounded-full bg-gold px-3 py-1 text-xs font-bold uppercase tracking-widest text-ink">
            <Crown className="-mt-0.5 mr-1 inline h-3 w-3" />The Standard
          </div>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">Garage Kings YEG</p>
          <h3 className="mt-2 font-display text-3xl tracking-wide text-white">The Premium Reset</h3>
          <ul className="mt-6 space-y-4">
            {us.map((t) => (
              <li key={t} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-gold">
                  <Check className="h-4 w-4 text-ink" />
                </span>
                <span className="text-white/90">{t}</span>
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </div>
  </section>
);
